//#region src/modules/RecordsFieldOptionsConfig/utils.ts
function toOptions(values) {
	if (!values) return [];
	return values.map((value) => ({
		label: value,
		value
	}));
}
/**
* Returns options for a field, ensuring `existingValue` is included even if
* not present in the current option list. Preserves order of the source list
* and appends `existingValue` at the end when it's a non-empty unknown value.
*/
function toOptionsWithExisting(values, existingValue) {
	const base = toOptions(values);
	if (!existingValue) return base;
	const trimmed = existingValue.trim();
	if (!trimmed) return base;
	if (base.some((opt) => opt.value.toLowerCase() === trimmed.toLowerCase())) return base;
	return [...base, {
		label: existingValue,
		value: existingValue
	}];
}
//#endregion
export { toOptions, toOptionsWithExisting };

//# sourceMappingURL=utils.js.map